<div class="change-password-page">
  <app-header
    [title]="'Changer mon mot de passe'"
    [showBackButton]="true"
    [showMenu]="false"
    [usePageBackground]="true"
  ></app-header>

  <div class="page-content">
    <!-- Confirmation -->
    @if (isSubmitted()) {
    <div class="confirmation-container">
      <div class="confirmation-icon">✅</div>
      <h2>Mot de passe modifié !</h2>
      <p class="confirmation-message">
        Ton mot de passe a été changé avec succès.<br />
        Utilise ton nouveau mot de passe lors de ta prochaine connexion.
      </p>
      <button type="button" class="btn-back" (click)="goBack()">Retour à mon compte</button>
    </div>
    } @else {
    <!-- Introduction -->
    <div class="intro-section">
      <div class="intro-icon">🔒</div>
      <p class="intro-text">
        Pour des raisons de sécurité, entre ton mot de passe actuel puis choisis un nouveau mot de
        passe.
      </p>
    </div>

    <!-- Formulaire -->
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="password-form">
      <!-- Mot de passe actuel -->
      <div class="form-group">
        <label for="currentPassword">Mot de passe actuel *</label>
        <div class="password-input-wrapper">
          <input
            [type]="showCurrentPassword() ? 'text' : 'password'"
            id="currentPassword"
            formControlName="currentPassword"
            placeholder="Entre ton mot de passe actuel"
            [class.invalid]="isFieldInvalid('currentPassword')"
          />
          <button
            type="button"
            class="toggle-password"
            (click)="togglePasswordVisibility('current')"
            [attr.aria-label]="
              showCurrentPassword() ? 'Masquer le mot de passe' : 'Afficher le mot de passe'
            "
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6z" />
              <circle cx="12" cy="12" r="3" />
              @if (showCurrentPassword()) {
              <line x1="4" y1="20" x2="20" y2="4" />
              }
            </svg>
          </button>
        </div>
        @if (isFieldInvalid('currentPassword')) {
        <span class="error-text">Le mot de passe actuel est requis</span>
        }
      </div>

      <!-- Nouveau mot de passe -->
      <div class="form-group">
        <label for="newPassword">Nouveau mot de passe *</label>
        <div class="password-input-wrapper">
          <input
            [type]="showNewPassword() ? 'text' : 'password'"
            id="newPassword"
            formControlName="newPassword"
            placeholder="Min. 8 caractères"
            [class.invalid]="isFieldInvalid('newPassword')"
          />
          <button type="button" class="toggle-password" (click)="togglePasswordVisibility('new')">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6z" />
              <circle cx="12" cy="12" r="3" />
              @if (showNewPassword()) {
              <line x1="4" y1="20" x2="20" y2="4" />
              }
            </svg>
          </button>
        </div>
        @if (isFieldInvalid('newPassword')) {
        <span class="error-text">Le mot de passe doit contenir au moins 8 caractères</span>
        }
      </div>

      <!-- Confirmer le mot de passe -->
      <div class="form-group">
        <label for="confirmPassword">Confirmer le nouveau mot de passe *</label>
        <div class="password-input-wrapper">
          <input
            [type]="showConfirmPassword() ? 'text' : 'password'"
            id="confirmPassword"
            formControlName="confirmPassword"
            placeholder="Confirme ton nouveau mot de passe"
            [class.invalid]="isFieldInvalid('confirmPassword') || form.hasError('passwordMismatch')"
          />
          <button
            type="button"
            class="toggle-password"
            (click)="togglePasswordVisibility('confirm')"
            [attr.aria-label]="
              showConfirmPassword() ? 'Masquer le mot de passe' : 'Afficher le mot de passe'
            "
          >
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6z" />
              <circle cx="12" cy="12" r="3" />
              @if (showConfirmPassword()) {
              <line x1="4" y1="20" x2="20" y2="4" />
              }
            </svg>
          </button>
        </div>
        @if (isFieldInvalid('confirmPassword')) {
        <span class="error-text">La confirmation est requise</span>
        } @if (form.hasError('passwordMismatch') && form.get('confirmPassword')?.touched) {
        <span class="error-text">Les mots de passe ne correspondent pas</span>
        }
      </div>

      <!-- Erreur serveur -->
      @if (errorMessage()) {
      <div class="error-banner">
        {{ errorMessage() }}
      </div>
      }

      <!-- Bouton submit -->
      <button type="submit" class="btn-submit" [disabled]="isSubmitting()">
        @if (isSubmitting()) {
        <span class="spinner"></span>
        Modification en cours... } @else { Changer mon mot de passe }
      </button>
    </form>
    }
  </div>
</div>
